(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[442],{

/***/ 58939:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/store-locator",
      function () {
        return __webpack_require__(57908);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 57908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _home_senco_uae_ui_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_senco_uae_ui_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_senco_uae_ui_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _api_endpoints__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3557);
/* harmony import */ var _api_http_client__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55642);
/* harmony import */ var _react_google_maps_api__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(37054);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var react_loading_skeleton__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(84849);
/* harmony import */ var _layout_layout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70081);
/* harmony import */ var _styles_store_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16903);
/* harmony import */ var _styles_store_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_store_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_select__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31578);











var containerStyle = {
    width: "100%",
    height: "500px"
};
var libraries = [
    "geometry"
];
var StoreLocator = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(null), map = ref[0], setMap = ref[1];
    var onLoad = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function callback(map) {
        setMap(map);
    }, []);
    var onUnmount = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function callback(map) {
        setMap(null);
    }, []);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)({
        lat: 21.767,
        lng: 78.871
    }), center = ref1[0];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(null), openInfo = ref2[0], setOpenInfo = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(true), loading = ref3[0], setLoading = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)([]), stores = ref4[0], setStores = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(null), state = ref5[0], setState = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(null), city = ref6[0], setCity = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(null), store = ref7[0], setStore = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(""), locationError = ref8[0], setLocationError = ref8[1];
    var states = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        return Array.from(new Set(stores.map(function(v) {
            return v.store_state;
        })));
    }, [
        stores
    ]);
    var cities = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        return Array.from(new Set(stores.filter(function(v) {
            return v.store_state == (state === null || state === void 0 ? void 0 : state.value);
        }).map(function(v) {
            return v.store_city;
        })));
    }, [
        stores,
        state
    ]);
    var storeOptions = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        return stores.filter(function(v) {
            return v.store_city == (city === null || city === void 0 ? void 0 : city.value);
        });
    }, [
        stores,
        city
    ]);
    var visibleStores = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        if (store) {
            return stores.filter(function(v) {
                return v.store_code == store.value;
            });
        }
        if (city) {
            return stores.filter(function(v) {
                return v.store_city == city.value;
            });
        }
        if (state) {
            return stores.filter(function(v) {
                return v.store_state == state.value;
            });
        }
        return stores;
    }, [
        stores,
        state,
        city,
        store
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        loadStoresData();
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (visibleStores.length && map) {
            var bounds = new google.maps.LatLngBounds();
            visibleStores.forEach(function(store) {
                bounds.extend(new google.maps.LatLng(parseFloat(store.store_lat), parseFloat(store.store_long)));
            });
            map.fitBounds(bounds);
        }
    }, [
        visibleStores,
        map
    ]);
    var loadStoresData = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_home_senco_uae_ui_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var data;
            return _home_senco_uae_ui_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _api_http_client__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get(_api_endpoints__WEBPACK_IMPORTED_MODULE_2__/* ["default"].storesData */ .Z.storesData());
                    case 2:
                        data = _ctx.sent.data;
                        setStores(data.data);
                        setLoading(false);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function loadStoresData() {
            return _ref.apply(this, arguments);
        };
    }();
    var useMyCurrentLocation = function() {
        setState(null);
        setCity(null);
        setStore(null);
        setLocationError("");
        if (window.navigator.geolocation) {
            window.navigator.geolocation.getCurrentPosition(function(data) {
                var location = new google.maps.LatLng(data.coords.latitude, data.coords.longitude);
                var nearestLocation = visibleStores.map(function(store) {
                    return {
                        lat: parseFloat(store.store_lat),
                        lng: parseFloat(store.store_long)
                    };
                }).reduce(function(prev, curr) {
                    var cpos = google.maps.geometry.spherical.computeDistanceBetween(location, curr);
                    var ppos = google.maps.geometry.spherical.computeDistanceBetween(location, prev);
                    return cpos < ppos ? curr : prev;
                });
                if (nearestLocation) {
                    var bounds = new google.maps.LatLngBounds();
                    bounds.extend(new google.maps.LatLng(parseFloat(nearestLocation.lat), parseFloat(nearestLocation.lng)));
                    map.fitBounds(bounds);
                }
            }, function(error) {
                setLocationError(error.message || "An unknown error occurred");
            });
        } else {
            setLocationError("Geolocation is not supported by this browser");
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("section", {
            className: (_styles_store_module_scss__WEBPACK_IMPORTED_MODULE_7___default().Store_section),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "row d-flex justify-content-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "col-md-12",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
                                    className: (_styles_store_module_scss__WEBPACK_IMPORTED_MODULE_7___default().explore),
                                    children: "Explore Our Store"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: "row mb-md-0 mb-2",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "col-md-3",
                                            children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                style: {
                                                    height: 40
                                                },
                                                className: "my-2 my-md-4 pt-1"
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_select__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                                                className: "my-2 my-md-4 pt-1",
                                                placeholder: "Select State",
                                                isClearable: true,
                                                value: state,
                                                onChange: function(e) {
                                                    setState(e);
                                                    setCity(null);
                                                    setStore(null);
                                                },
                                                options: states.map(function(city) {
                                                    return {
                                                        value: city,
                                                        label: city
                                                    };
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "col-md-3",
                                            children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                style: {
                                                    height: 40
                                                },
                                                className: "my-2 my-md-4 pt-1"
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_select__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                                                className: "my-2 my-md-4 pt-1",
                                                placeholder: "Select City",
                                                isClearable: true,
                                                value: city,
                                                onChange: function(e) {
                                                    setCity(e);
                                                    setStore(null);
                                                },
                                                options: cities.map(function(city) {
                                                    return {
                                                        value: city,
                                                        label: city
                                                    };
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "col-md-3",
                                            children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                style: {
                                                    height: 40
                                                },
                                                className: "my-2 my-md-4 pt-1"
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_select__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                                                className: "my-2 my-md-4 pt-1",
                                                placeholder: "Select Store",
                                                isClearable: true,
                                                value: store,
                                                onChange: function(e) {
                                                    setStore(e);
                                                },
                                                options: storeOptions.map(function(store) {
                                                    return {
                                                        value: store.store_code,
                                                        label: store.store_name
                                                    };
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "col-md-3",
                                            children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                style: {
                                                    height: 40
                                                },
                                                className: "my-2 my-md-4 pt-1"
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                                        role: "button",
                                                        "aria-label": "USE MY CURRENT LOCATION",
                                                        className: "".concat((_styles_store_module_scss__WEBPACK_IMPORTED_MODULE_7___default().btn), " ").concat(locationError ? "mb-2" : ""),
                                                        onClick: useMyCurrentLocation,
                                                        children: "USE MY CURRENT LOCATION"
                                                    }),
                                                    locationError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                        className: "text-danger",
                                                        children: locationError
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: (_styles_store_module_scss__WEBPACK_IMPORTED_MODULE_7___default().total_store),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("strong", {
                                        children: [
                                            store ? store.label : city ? city === null || city === void 0 ? void 0 : city.label : (state === null || state === void 0 ? void 0 : state.label) || "Total",
                                            " ",
                                            visibleStores.length,
                                            " Stores"
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "mb-4 row",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "col-md-12",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_react_google_maps_api__WEBPACK_IMPORTED_MODULE_10__/* .LoadScript */ .KJ, {
                                googleMapsApiKey: "AIzaSyCbM-gcKYhz6xomaWyna28XTi3AtCucbrg",
                                libraries: libraries,
                                loadingElement: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    style: containerStyle
                                }),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_react_google_maps_api__WEBPACK_IMPORTED_MODULE_10__/* .GoogleMap */ .b6, {
                                    mapContainerStyle: containerStyle,
                                    center: center,
                                    zoom: 2,
                                    onLoad: onLoad,
                                    onUnmount: onUnmount,
                                    children: visibleStores.map(function(store) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_react_google_maps_api__WEBPACK_IMPORTED_MODULE_10__/* .Marker */ .Jx, {
                                            position: {
                                                lat: parseFloat(store.store_lat),
                                                lng: parseFloat(store.store_long)
                                            },
                                            onClick: function() {
                                                return setOpenInfo(store.store_code);
                                            },
                                            children: openInfo == store.store_code && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_react_google_maps_api__WEBPACK_IMPORTED_MODULE_10__/* .InfoWindow */ .nx, {
                                                onCloseClick: function() {
                                                    return setOpenInfo(null);
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    className: "container-fluid",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        className: "row",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                            className: "col-md-12",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h5", {
                                                                    className: "text-center",
                                                                    style: {
                                                                        color: "#FF1933",
                                                                        textTransform: "uppercase"
                                                                    },
                                                                    children: store.store_name
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                                                            className: "bi bi-signpost"
                                                                        }),
                                                                        " ",
                                                                        store.map_address
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                                                            className: "bi bi-telephone"
                                                                        }),
                                                                        " ",
                                                                        store.store_phoneno
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                                                            className: "bi bi-envelope"
                                                                        }),
                                                                        " ",
                                                                        store.store_email
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                                                            className: "bi bi-clock"
                                                                        }),
                                                                        " ",
                                                                        store.map_timing_text
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                                                    role: "button",
                                                                    "aria-label": "Your LOCATION",
                                                                    className: (_styles_store_module_scss__WEBPACK_IMPORTED_MODULE_7___default().btn),
                                                                    onClick: function() {
                                                                        return window.open("https://www.google.es/maps/dir/Your+Location/".concat(encodeURIComponent(store.map_address)), "_blank");
                                                                    },
                                                                    children: "Get Direction"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            })
                                        }, store.store_code);
                                    })
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
};
StoreLocator.getLayout = function(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_layout_layout__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        children: page
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (StoreLocator);


/***/ }),

/***/ 16903:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb_main":"store_breadcrumb_main__L57Ta","btn":"store_btn__REnEJ","Store_section":"store_Store_section__qHb_r","border_bottom":"store_border_bottom__dpI_P","image_container":"store_image_container__y90rR","explore":"store_explore__xx6I_","select_state":"store_select_state__UoiG_","store_details":"store_store_details__jQzIr","contact_details":"store_contact_details__kl4cA","book_button":"store_book_button__TNL8Z","book_appointment":"store_book_appointment__ArW1b","view_map":"store_view_map__cNEsw","total_store":"store_total_store__pTaIb","mb-30":"store_mb-30__2acCo"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1255,959,1387,6667,3564,3278,9774,2888,179], function() { return __webpack_exec__(58939); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);